
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12","cy":"12","r":"10","fill":"#5DD25E"}}),_c('path',{attrs:{"d":"M10.074 16H8.426l2.51-7.273h1.982L15.427 16h-1.648l-1.822-5.61H11.9L10.074 16zm-.103-2.859h3.892v1.2H9.971v-1.2z","fill":"#000"}})])
          )
        }
      }
    